import * as React from 'react';
import { useState } from 'react';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Menu from '../../assets/icons/NavbarIcon/menu-03.png'
import { Box, Typography } from '@mui/material';
import SideCancel from '../../assets/icons/NavbarIcon/Cancel.png'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useCategories, useSubCategories } from '../../hooks/shop/useCategory';
import { useUnreadCount } from '../../hooks/useUnreadCount';

const SideCategoryItem = ({ category, handleNavigation }) => {
  const [expanded, setExpanded] = useState(false);
  const { data: subcategories = [], isLoading } = useSubCategories(expanded ? category.ID : null);

  const toggleExpand = (e) => {
    e.stopPropagation();
    setExpanded(!expanded);
  };

  return (
    <Accordion 
      disableGutters 
      elevation={0} 
      square 
      sx={{ 
        '&:before': { display: 'none' }, 
        bgcolor: 'transparent',
        p: 0, m: 0
      }}
      expanded={expanded}
      onChange={toggleExpand}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{ minHeight: 'auto', p: 0, m: 0, '& .MuiAccordionSummary-content': { m: 0, p: '10px 0' } }}
      >
        <Link 
          to={`/shop/${category.ID}`} 
          style={{ textDecoration: "none", color: "rgba(122, 126, 133, 1)", fontSize: "18px" }}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleNavigation(`/shop/${category.ID}`); }}
        >
          {category.Category}
        </Link>
      </AccordionSummary>
      <AccordionDetails sx={{ p: '0 0 0 16px' }}>
        {isLoading && <Typography sx={{ fontSize: '14px', color: 'gray' }}>Loading...</Typography>}
        {!isLoading && subcategories.map(sub => (
          <Box key={sub.ID} sx={{ pb: 1 }}>
             <Link 
               to={`/shop/${category.ID}/${sub.ID}`} 
               style={{ textDecoration: "none", color: "rgba(122, 126, 133, 1)", fontSize: "16px" }}
               onClick={(e) => { e.preventDefault(); handleNavigation(`/shop/${category.ID}/${sub.ID}`); }}
             >
               {sub.SUBCATG}
             </Link>
          </Box>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};




function SideMenu({ isAuthenticated, setIsAuthenticated, isApproved }) {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { data: categories = [], isLoading: categoriesLoading } = useCategories({ enabled: !!(isAuthenticated && isApproved) });
    const unreadCount = useUnreadCount(isAuthenticated && isApproved);

    React.useEffect(() => {
      setOpen(false);
    }, [location.pathname]);

    const handleNavigation = (path) => {
      setOpen(false); // Close the drawer
      if (path) {
        setTimeout(() => {
          navigate(path);
        }, 200);
      }
    };

    const handleLogout = () => {
      localStorage.clear();
      if (setIsAuthenticated) setIsAuthenticated(false);
      setOpen(false);
      setTimeout(() => {
        navigate("/login");
      }, 200);
    };

    return (
      <Box>
        <Button onClick={() => setOpen(true)} sx={{ color: 'white' }}>
          <img src={Menu} alt="" />
        </Button>

        <Drawer
          anchor={"left"}
          open={open}
          onClose={() => setOpen(false)}
        >
          <Box
            sx={{
              width: "300px",
              display: "flex",
              flexDirection: "column",
              padding: "10%"
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%"
              }}
            >
              <Box>
                <Typography sx={{
                  fontSize: "22px",
                  fontWeight: "600",
                  color: "rgba(105, 83, 55, 1)",
                }}>Menu</Typography>
              </Box>

              <Box sx={{
                width: "40px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                zIndex: 2,
              }}
                onClick={() => setOpen(false)}
              >
                <img
                  src={SideCancel}
                  alt="Close Menu"
                  style={{
                    width: "20px",
                    height: "20px",
                  }}
                />
              </Box>
            </Box>

            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                marginTop: "20%",
              }}
            >
              <Link style={{ textDecoration: "none", color: "rgba(122, 126, 133, 1)", marginBottom: "10%", fontSize: "20px" }} to="/" onClick={(e) => { e.preventDefault(); handleNavigation("/"); }}> Home</Link>
              
              {isAuthenticated && isApproved && (
                <Accordion 
                  disableGutters 
                  elevation={0} 
                  square 
                  sx={{ 
                    '&:before': { display: 'none' }, 
                    bgcolor: 'transparent',
                    p: 0, mb: "10%"
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{ minHeight: 'auto', p: 0, m: 0, '& .MuiAccordionSummary-content': { m: 0 } }}
                  >
                    <Typography sx={{ color: "rgba(122, 126, 133, 1)", fontSize: "20px" }}>Shop</Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: '10px 0 0 10px', maxHeight: '40vh', overflowY: 'auto' }}>
                    {categoriesLoading ? (
                      <Typography sx={{ fontSize: '14px', color: 'gray' }}>Loading Categories...</Typography>
                    ) : (
                      categories.map(category => (
                        <SideCategoryItem key={category.ID} category={category} handleNavigation={handleNavigation} />
                      ))
                    )}
                  </AccordionDetails>
                </Accordion>
              )}

              <Link style={{ textDecoration: "none", color: "rgba(122, 126, 133, 1)", marginBottom: "10%", fontSize: "20px" }} to="/catalogues" onClick={(e) => { e.preventDefault(); handleNavigation("/catalogues"); }}> Catalogues</Link>
              {isAuthenticated && isApproved && <Link style={{ textDecoration: "none", color: "rgba(122, 126, 133, 1)", marginBottom: "10%", fontSize: "20px" }} to="/Wishlist" onClick={(e) => { e.preventDefault(); handleNavigation("/Wishlist"); }}> Wishlist </Link>}
              {isAuthenticated && isApproved && (
                <Link 
                  style={{ 
                    textDecoration: "none", 
                    color: "rgba(122, 126, 133, 1)", 
                    marginBottom: "10%", 
                    fontSize: "20px",
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                  }} 
                  to="/chat" 
                  onClick={(e) => { e.preventDefault(); handleNavigation("/chat"); }}
                >
                  Chat with us
                  {unreadCount > 0 && (
                    <Box sx={{ 
                      minWidth: '20px', 
                      height: '20px', 
                      bgcolor: '#695337', 
                      color: 'white', 
                      borderRadius: '50%', 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      fontSize: '0.7rem',
                      fontWeight: 700,
                      px: 0.5
                    }}>
                      {unreadCount}
                    </Box>
                  )}
                </Link>
              )}
              {isAuthenticated && isApproved && <Link style={{ textDecoration: "none", color: "rgba(122, 126, 133, 1)", marginBottom: "10%", fontSize: "20px" }} to="/profile" onClick={(e) => { e.preventDefault(); handleNavigation("/profile"); }}> My Profile</Link>}
              {isAuthenticated && isApproved && <Link style={{ textDecoration: "none", color: "rgba(122, 126, 133, 1)", marginBottom: "10%", fontSize: "20px" }} to="/myorder" onClick={(e) => { e.preventDefault(); handleNavigation("/myorder"); }}> My Orders</Link>}
              {isAuthenticated && isApproved && <Link style={{ textDecoration: "none", color: "rgba(122, 126, 133, 1)", marginBottom: "10%", fontSize: "20px" }} to="/myquotations" onClick={(e) => { e.preventDefault(); handleNavigation("/myquotations"); }}> My Quotations</Link>}
              <Link style={{ textDecoration: "none", color: "rgba(122, 126, 133, 1)", marginBottom: "10%", fontSize: "20px" }} to="/About" onClick={(e) => { e.preventDefault(); handleNavigation("/About"); }}> About us</Link>
              <Link style={{ textDecoration: "none", color: "rgba(122, 126, 133, 1)", marginBottom: "10%", fontSize: "20px" }} to="/Contactus" onClick={(e) => { e.preventDefault(); handleNavigation("/Contactus"); }}> Contact Us</Link>
              
              {isAuthenticated ? (
                <Typography 
                  onClick={handleLogout}
                  style={{ 
                    textDecoration: "none", 
                    color: "rgba(105, 83, 55, 1)", 
                    fontSize: "20px", 
                    marginTop: "10%",
                    cursor: "pointer",
                    fontWeight: "600"
                  }}
                >
                  Logout
                </Typography>
              ) : (
                <>
                  <Link 
                    style={{ textDecoration: "none", color: "rgba(122, 126, 133, 1)", marginBottom: "10%", fontSize: "20px" }} 
                    to="/login" 
                    onClick={(e) => { e.preventDefault(); handleNavigation("/login"); }}
                  >
                    Login
                  </Link>
                  <Link 
                    style={{ 
                      textDecoration: "none", 
                      color: "rgba(105, 83, 55, 1)", 
                      fontSize: "20px", 
                      marginTop: "10%",
                      fontWeight: "600" 
                    }} 
                    to="/register" 
                    onClick={(e) => { e.preventDefault(); handleNavigation("/register"); }}
                  >
                    Signup
                  </Link>
                </>
              )}
            </Box>
          </Box>
        </Drawer>
      </Box>
    )
}


export default SideMenu
